<template>
  <div class="check-list-person auto-list_col_centered">
    <div
      style="white-space: nowrap; overflow: hidden; tsext-overflow: ellipsis"
    >
      <p class="check-list-phone grey">
        {{
          responseAuto && responseAuto.carrier_name !== null
            ? responseAuto.carrier_name
            : 'Нет данных'
        }}
      </p>
      <el-rate
        v-if="!isMobile && !isAdminOrCeoRole"
        v-model="rateUser"
        disabled
        :colors="rateColor"
      />
      <el-rate
        v-if="!isMobile && isAdminOrCeoRole && !responseAuto.inn_owner"
        v-model="rateUser"
        disabled
        :colors="rateColor"
      />
      <span v-if="!isMobile && isAdminOrCeoRole && responseAuto.inn_owner">
        <el-skeleton :loading="loading" animated :throttle="500">
          <template slot="template">
            <el-skeleton-item variant="text" />
          </template>
          <span class="buttons-wrapper">
            <span class="buttons-wrapper" @click.stop="showComments">
              <el-button class="button-img">
                <img src="@/assets/img/like.svg" alt="like" />
                <span class="green">{{ '+ ' + gradeComments.positive }}</span>
              </el-button>
              <el-button class="button-img dislike">
                <img src="@/assets/img/dislike.svg" alt="dislike" />
                <span class="red">{{ '+ ' + gradeComments.negative }}</span>
              </el-button>
              <el-button class="button-img grey">
                <img src="@/assets/img/massage.svg" alt="dislike" />
                <span class="gray">
                  {{ gradeComments.positive + gradeComments.negative }}
                </span>
              </el-button>
            </span>
            <span class="plus-icon">
              <i class="el-icon-circle-plus" @click.stop="addComment" />
            </span>
          </span>
        </el-skeleton>
      </span>
      <span>
        <span class="buttons-wrapper">
          <span class="buttons-wrapper">
            <p
              :style="`color: ${status[contractStatus].color}`"
              style="font-size: 14px"
            >
              {{ status[contractStatus].title }}
            </p>
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Comments = RepositoryFactory.get('comments')

export default {
  name: 'Carrier',
  props: {
    responseAutoInn: {
      type: String,
      default: '',
    },
    contragentName: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: 0,
    },
    contractStatus: {
      type: Number,
      default: 0,
    },
    responseUserRole: {
      type: String,
      default: '',
    },
    responseAuto: {
      type: Object,
      default: () => {},
    },
    rateColor: {
      type: Array,
      default: () => ['#3498DB', '#3498DB', '#3498DB'],
    },
  },
  data() {
    return {
      status: [
        { title: 'нет договора', color: '#F56C6C' },
        { title: 'довор не подписан', color: '#E6A23C' },
        { title: 'договор подписан ', color: '#67C23A' },
      ],
      allAutoOwnerComments: [],
      positive: 0,
      negative: 0,
      loading: false,
      rateUser: 3,
    }
  },
  computed: {
    gradeComments() {
      return {
        positive: this.allAutoOwnerComments.filter(
          item => item.is_positive === 1,
        ).length,
        negative: this.allAutoOwnerComments.filter(
          item => item.is_positive === 0,
        ).length,
      }
    },
  },
  watch: {
    countComments() {
      if (this.responseAuto.inn_owner === this.responseAutoInn) {
        this.fetchAutoOwnerComment()
      }
    },
  },
  created() {
    this.fetchAutoOwnerComment()
  },
  methods: {
    fetchAutoOwnerComment() {
      if (this.responseAuto.inn_owner) {
        this.loading = true
        Comments.getComments(this.responseAuto.inn_owner)
          .then(res => {
            this.allAutoOwnerComments = res.data
          })
          .catch(e => console.log(`[fetchComments] err: `, e))
          .finally(() => {
            this.loading = false
          })
      }
    },
    addComment() {
      this.$emit('addComment', this.id, this.responseAuto.inn_owner)
    },
    showComments() {
      this.$emit(
        'showCommentsModal',
        this.allAutoOwnerComments,
        this.responseAuto.carrier_name,
      )
    },
  },
}
</script>

<style lang="sass">
.buttons-wrapper
  padding: 0px
  display: flex
  justify-content: space-around
  align-items: center
  .plus-icon
    color: #d7d7d7
    transition: 0.3s
    height: 20px
    display: flex
    justify-content: flex-start
    align-items: center
    font-size: 22px
    margin-bottom: 8px
    &:hover
      color: #2ECC71
  .button-img
    padding: 0px
    cursor: pointer
    height: 20px
    background: none
    border: none
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 14px
    margin-bottom: 8px
    &:hover
      background: none
    img
      margin-right: 6px
    .green
      color: #00AF37
      font-size: 18px
    .red
      color: #C21616
      font-size: 18px
    .gray
      font-size: 18px
      color: #939495

@media (max-width: 1024px)
  .buttons-wrapper
    flex-wrap: wrap
</style>
